<!--
 * @Author: 陈梦男
 * @Date: 2024-05-22 14:44:21
 * @LastEditTime: 2024-12-25 11:28:09
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 报告数据管理--查询条件
 * @FilePath: \web\src\components\ReportComponents\DataManager\search.vue
-->
<template>
  <section class="trend-search">
    <section class="search-item" style="width: 2.2rem">
      <div class="search-item-text">报告名称：</div>
      <a-input placeholder="请输入报告名称" v-model:value="requestParams.name" />
    </section>
    <section class="search-item" style="width: 3.2rem">
      <div class="search-item-text">指标时间：</div>
      <a-range-picker v-model:value="requestParams.timeRange" />
    </section>

    <section class="search-item" style="width: 2.2rem" v-if="type === '国别报告'">
      <div class="search-item-text">国家：</div>
      <a-input placeholder="国家" v-model:value="requestParams.country" />
    </section>
    <section class="search-item" style="width: 2.2rem" v-if="type === '矿种报告'">
      <div class="search-item-text">矿种：</div>
      <a-input placeholder="矿种" v-model:value="requestParams.minerals" />
    </section>
    <slot name="trendBtns">
      <div class="btn-wrapper">
        <div class="reset-btn btn-item" @click="resetSearch">重置</div>
        <div class="search-btn btn-item" @click="submitSearch()">查询</div>
      </div>
    </slot>
  </section>
</template>

<script setup>
import { ref, reactive, defineProps, defineEmits, } from 'vue';

const props = defineProps({
  type: {
    type: String,
  },
});

const timeRange = ref([]);

const requestParams = reactive({
  name: '',
  country: '',
  timeRange: null,
  minerals: '',
});
const emit = defineEmits(['submit',]);

/**
 * @description 查询
 */
const submitSearch = async () => {

  await emit('submit', requestParams);
};

/**
 * @description 重置
 */
const resetSearch = async () => {
  timeRange.value = [];
  requestParams.name = '';
  requestParams.country = '';
  requestParams.timeRange = null;
  requestParams.minerals = '';
  await emit('submit', {});
};


</script>

<style lang='scss'>
.trend-search {
  display: flex;

  .search-item {
    width: 1.8rem;
    height: 0.34rem;
    margin-right: 0.05rem;
    display: flex;

    .search-item-text {
      color: #fff;
      width: 1.1rem;
      text-align: right;
      height: 0.34rem;
      line-height: 0.34rem;
    }
  }

  /* 输入框 */
  .ant-input {
    color: white;
    background-color: rgba(91, 76, 39, 0.4);
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    border: transparent;
  }

  .ant-input-suffix {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: .02rem;
  }

  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;

    .ant-select-selector {
      height: 100%;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      background-color: rgba(91, 76, 39, 0.4);
      border: none;
      color: #fff;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      color: #fff;
      padding-right: 0;
    }
  }

  /* 输入框 */
  .ant-input {
    color: white;
    background-color: rgba(91, 76, 39, 0.4);
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    border: transparent;
    padding-top: 0rem;
    padding-bottom: 0rem;
    height: 100%;
  }

  .ant-input-suffix {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: .02rem;
  }

  .btn-wrapper {
    height: 0.32rem;
    line-height: 0.32rem;
    margin-left: 0.2rem;
    color: #ffffff;
    display: flex;
    padding: 0;

    .btn-item {
      width: 0.9rem;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .reset-btn {
      // background-color: #535962;
      background-image: url(~@/static/images/dataManagement/reset_btn.png);
      background-size: 100% 100%;
      margin-right: 0.05rem;
    }

    .search-btn {
      // background-color: #efb227;
      background-image: url(~@/static/images/dataManagement/submit_btn.png);
      background-size: 100% 100%;
    }
  }
}
</style>